<template>
  <v-container fluid class='px-0'>
    <v-layout>
      <v-flex xs11 sm12 md12>
      <h4 class='display-1' :style="findRailBusName(this.$route.params.id)" >{{railname}} <v-icon large id='iconTitle' :style="findRailBusName(this.$route.params.id)" >{{iconVal}}</v-icon></h4>
     <display-selector :data="displayData" @selectedItem="showMaps" :railId="dataObj.id" :showBtn = "toggleBtn" @toggleBtn="tgBtn"
      :cr="findRailBusName(this.$route.params.id)" >
      </display-selector>
        <template v-if = "toogleGrid">
          <display-grid :dat="displayResults" :mapsData="data" :issues="issuesDat" :railId="dataObj.id" :showButton="showButton"
          :cr="findRailBusName(this.$route.params.id)" :showDisplayCaseSelector = "showCaseSelector"></display-grid>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import DisplaySelector from './displays/DisplaySelector'
import DisplayGrid from './displays/DisplayGrid'
import {bus} from '../main'
import {mapGetters} from 'vuex'
export default {
  name: 'MainContent',
  components: {
    displaySelector: DisplaySelector,
    displayGrid: DisplayGrid
  },
  data () {
    return {
      railname: '',
      dataObj: '',
      sel: '',
      e: '',
      displayData: [],
      data: [],
      issuesDat: [],
      showFlag: false,
      showResults: false,
      showButton: false,
      showCaseSelector: false,
      displayResults: [],
      toogleGrid: false,
      toggleBtn: false,
      iconVal: this.getIcon(this.$route.params.id),
      showItem: false,
      show: '',
      test: ''
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  mounted () {
    var vm = this
    vm.dataObj = vm.findRailBusName(vm.$route.params.id)
    vm.railname = vm.dataObj.name
    vm.toogleGrid = true
    vm.$nextTick().then(function (obj) {
      axios.all([vm.getDisplay(), vm.getMaps(), vm.getIssues()])
      .then(axios.spread(function (display, maps, issues) {
        var temp = _.filter(display.data, function (i) {
          return i.portalFeature.length !== 0
        })
        vm.displayData = temp
        vm.data = maps.data
        vm.issuesDat = issues.data
      }))
    })
  },
  updated () {
    this.checkToken()
  },
  watch: {
    displayData () {
      var vm = this
      vm.displayData.forEach(function (el) {
        if (el.id === vm.sel) {
          if (el.portalFeature.length !== 0) {
            el.portalFeature.forEach(function (pf) {
              vm.displayResults = pf.featureDisplay
            })
          }
        }
      })
      this.sortDisplayResults()
    }
  },
  beforeRouteUpdate (to, from, next) {
    var vm = this
    vm.dataObj = vm.findRailBusName(to.params.id)
    vm.railname = vm.dataObj.name
    vm.toogleGrid = false
    axios.all([vm.getDisplay(), vm.getMaps(), vm.getIssues()])
    .then(axios.spread(function (display, maps, issues) {
      var temp = _.filter(display.data, function (i) {
        return i.portalFeature.length !== 0
      })
      vm.displayData = temp
      vm.data = maps.data
      vm.issuesDat = issues.data
      vm.showResults = false
      vm.displayResults = []
      vm.showButton = false
      vm.toggleBtn = false
      vm.sel = ''
      vm.showCaseSelector = false
    }))
    next()
  },
  created () {
    if (!this.checkToken()) {
      var vm = this
      vm.dataObj = this.findRailBusName(this.$route.params.id)
      vm.toogleGrid = true
      bus.$on('saveForm', (data) => {
        axios.all([vm.getDisplay(), vm.getMaps(), vm.getIssues()])
        .then(axios.spread(function (display, maps, issues) {
          var temp = _.filter(display.data, function (i) {
            return i.portalFeature.length !== 0
          })
          vm.displayData = temp
          vm.data = maps.data
          vm.issuesDat = issues.data
          vm.showMaps(vm.sel)
        }))
      })
    }
  },
  methods: {
    showMaps (selected) {
      this.sel = selected
      var vm = this
      vm.showFlag = true
      vm.results = ''
      vm.displayData.forEach(function (el) {
        if (el.id === vm.sel) {
          if (el.portalFeature.length !== 0) {
            el.portalFeature.forEach(function (pf) {
              vm.displayResults = pf.featureDisplay
            })
            vm.showButton = true
            vm.showResults = false
            vm.toogleGrid = true
            vm.showCaseSelector = true
          } else {
            vm.showResults = false
            vm.displayResults = ''
            vm.showButton = false
            vm.toogleGrid = false
            vm.showCaseSelector = false
          }
        }
      })
      this.sortDisplayResults()
    },
    sortDisplayResults () {
      this.displayResults.forEach(item => {
        var c = item.code.split('_')[2].length === 2 ? item.code.split('_')[2].substr(0, 1) : item.code.split('_')[2].substr(0, 2)
        item.caseNum = parseInt(c)
      })
      var arr = _.orderBy(this.displayResults, ['caseNum'], ['asc'])
      var results = []
      arr.forEach(i => {
        if (i.status !== 'Disable') {
          results.push(i)
        }
      })
      this.displayResults = results
    },
    checkToken () {
      if (window.localStorage.length === 0) {
        this.$router.push('/')
      } else {
        let vm = new Date()
        let v = new Date(this.currentUser.exp * 1000)
        if (!(vm.getTime() < v.getTime())) {
          this.$store.dispatch('logout')
        } else {
          return false
        }
      }
    },
    tgBtn () {
      this.toggleBtn = true
    },
    getDisplay () {
      var vm = this
      var urlA = '/mapsdata/portal/display/' + vm.dataObj.id
      return vm.$http.get(urlA)
    },
    getMaps () {
      var vm = this
      var urlB = '/mapsdata/display/maps/rail_id/' + vm.dataObj.id
      return vm.$http.get(urlB)
    },
    getIssues () {
      var vm = this
      var urlC = '/mapsdata/display/issues/rail_id/' + vm.dataObj.id
      return vm.$http.get(urlC)
    },
    findRailBusName (params) {
      let obj = {id: '', name: '', color: ''}
      if (params === '801') {
        obj.id = params
        obj.name = 'Metro Blue Line'
        obj.color = '#3F51B5' // indigo
        obj.colorName = 'indigo'
        return obj
      } else if (params === '802') {
        obj.id = params
        obj.name = 'Metro Red Line'
        obj.color = '#F44336' // red
        obj.colorName = 'red'
        return obj
      } else if (params === '803') {
        obj.id = params
        obj.name = 'Metro Green Line'
        obj.color = '#4CAF50' // green
        obj.colorName = 'green'
        return obj
      } else if (params === '804') {
        obj.id = params
        obj.name = 'Metro Gold Line'
        obj.color = '#FBC02D' // gold
        obj.colorName = 'yellow darken-2'
        return obj
      } else if (params === '805') {
        obj.id = params
        obj.name = 'Metro Purple Line'
        obj.color = '#673AB7' // purple
        obj.colorName = 'deep-purple lighten-1'
        return obj
      } else if (params === '806') {
        obj.id = params
        obj.name = 'Metro Expo Line'
        obj.color = '#2196F3' // expo
        obj.colorName = 'blue'
        return obj
      } else if (params === '901') {
        obj.id = params
        obj.name = 'Metro Orange Line'
        obj.color = '#FF9800' // orange
        obj.colorName = 'orange'
        return obj
      } else if (params === '910' || params === '950') {
        obj.id = params
        obj.name = 'Metro Silver Line'
        obj.color = '#9E9E9E' // red
        obj.colorName = 'grey'
        return obj
      } else {
        return ''
      }
    },
    getIcon (params) {
      if (params === '801' || params === '802' ||
        params === '803' || params === '804' ||
        params === '805' || params === '806') {
        return 'directions_railway'
      } else {
        return 'directions_bus'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .displayInfo ul{
    list-style: none;
    padding-left: 0;
    color:black;
  }
  .displayInfo ul li{
    display: inline;
    padding-left:0px;
  }
  .button-style{
    padding-top: 5px
  }
  .button-style button{
    padding-bottom: 1px;
  }
 .mapSelect{
    margin-bottom: 25px;
    padding-bottom: 15px;
 }
 .wrapper{
    margin: auto;
    text-align:center;
    color:blue;
 }
 .custom-caption{
  color:blue;
 }
 .custom-style{
   padding: 0;
 }
@media only screen and (min-width: 600px){
   .display-1{
     font-size:40pt;
   }
}
@media only screen and (max-width:600px) {
   #iconTitle {
    display:none;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/MainContent.vue